export default function CardsSection() {
  const cards = [
    {
      id: 1,
      title: '顶流男星深夜密会神秘女子，工作室紧急发声明否认',
      tag: '独家爆料',
      tagColor: 'accent',
      summary: '据知情人士透露，该男星近日在某高端酒店被拍到与一名女性同行，双方互动亲密。此事在今日黑料最新动态中引发轩然大波，粉丝群体已分为护主派与脱粉派激烈对峙。',
      image: 'https://readdy.ai/api/search-image?query=cinematic%20scene%20of%20paparazzi%20cameras%20flashing%20in%20darkness%2C%20red%20carpet%20atmosphere%2C%20dramatic%20spotlighting%2C%20dark%20background%20with%20warm%20highlights%2C%20entertainment%20industry%20mood%2C%20mysterious%20ambiance&width=800&height=500&seq=card-01&orientation=landscape',
    },
    {
      id: 2,
      title: '知名综艺节目导演被爆潜规则，多位参赛选手集体发声',
      tag: '追踪报道',
      tagColor: 'primary',
      summary: '该节目自开播以来收视率居高不下，但51黑料今日独家获取了多位选手的爆料材料，揭露选秀背后的不公平操作。黑料每日更新将持续跟进此事进展。',
      image: 'https://readdy.ai/api/search-image?query=mysterious%20silhouette%20of%20person%20behind%20frosted%20glass%20with%20text%20headlines%20reflected%2C%20modern%20office%20building%20at%20night%2C%20urban%20surveillance%20atmosphere%2C%20deep%20shadows%20with%20warm%20interior%20light%2C%20cinematic%20noir%20style&width=800&height=500&seq=card-02&orientation=landscape',
    },
    {
      id: 3,
      title: '千万粉丝网红直播翻车，产品虚假宣传遭消费者集体维权',
      tag: '热搜第一',
      tagColor: 'accent',
      summary: '该网红在最新直播中夸大产品功效，被专业机构检测打脸。目前已有超过5000名消费者加入维权群，最新黑料显示其团队正试图删帖控评。',
      image: 'https://readdy.ai/api/search-image?query=dramatic%20breaking%20news%20digital%20screen%20display%20with%20abstract%20data%20visualization%2C%20dark%20tech%20command%20center%20aesthetic%2C%20warm%20amber%20alert%20indicators%2C%20cinematic%20wide%20shot%2C%20modern%20newsroom%20atmosphere&width=800&height=500&seq=card-03&orientation=landscape',
    },
    {
      id: 4,
      title: '某知名品牌代言人突然解约，背后商业纠纷浮出水面',
      tag: '深度解读',
      tagColor: 'primary',
      summary: '品牌方与代言人之间的合约纠纷升级，涉及金额或达九位数。51黑料网从多方渠道获悉，此次解约并非表面那么简单，黑料新鲜事将持续深挖内幕。',
      image: 'https://readdy.ai/api/search-image?query=close%20up%20of%20smartphone%20screen%20displaying%20trending%20social%20media%20feed%20with%20dramatic%20red%20notification%20badges%2C%20dark%20ambient%20lighting%2C%20modern%20digital%20lifestyle%20scene%2C%20warm%20screen%20glow%20against%20darkness&width=800&height=500&seq=card-04&orientation=landscape',
    },
    {
      id: 5,
      title: '娱乐圈年度最大税务风波续：又有三位艺人被约谈',
      tag: '持续关注',
      tagColor: 'accent',
      summary: '继去年大规模查税行动后，最新消息显示又有三位当红艺人被税务部门约谈。51黑料今日从相关部门获悉，此轮清查范围将进一步扩大，每日黑料将持续更新名单。',
      image: 'https://readdy.ai/api/search-image?query=artistic%20abstract%20representation%20of%20information%20network%20spreading%20like%20fire%20embers%20in%20darkness%2C%20warm%20orange%20and%20amber%20particles%2C%20cinematic%20dramatic%20composition%2C%20mysterious%20and%20intense%20mood&width=800&height=500&seq=card-05&orientation=landscape',
    },
  ];

  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-400 bg-accent-100/15 px-3 py-1 rounded-full mb-4 whitespace-nowrap">
            <i className="ri-newspaper-line"></i>
            Latest Scoop
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            最新爆料
          </h2>
          <p className="text-sm text-foreground-500">今日黑料最新精选，每一条都值得细品</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card) => (
            <article
              key={card.id}
              className="bg-background-100 border border-background-200/60 rounded-lg overflow-hidden hover:border-background-300/60 transition-all group cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span
                    className={`inline-block px-2.5 py-1 rounded text-xs font-semibold whitespace-nowrap ${
                      card.tagColor === 'accent'
                        ? 'bg-accent-500/90 text-white'
                        : 'bg-primary-500/90 text-background-950'
                    }`}
                  >
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-100 mb-2.5 leading-snug group-hover:text-primary-400 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {card.summary}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}